import { render, staticRenderFns } from "./RequestInfoAdd.vue?vue&type=template&id=6d58dfce"
import script from "./RequestInfoAdd.vue?vue&type=script&lang=js"
export * from "./RequestInfoAdd.vue?vue&type=script&lang=js"
import style0 from "./RequestInfoAdd.vue?vue&type=style&index=0&id=6d58dfce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports